<script>
import FIcon from "../icon/FIcon.vue";
import FTextfield from "./FTextfield.vue";
export default {
  translate25Context: "vfigma",
  components: { FTextfield, FIcon },
  methods: {},
  props: {
    pending: Boolean,
    filename: String,
    change: Function,
    delete: Function,
    accept: String,
    noDelete: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    click: function ($event) {
      $(this.$el).find("input.inputfile").click();
    },
    onFileChange: function ($event) {
      this.file = $event.target.files || $event.dataTransfer.files;
      this.$emit("change", $event.target.files || $event.dataTransfer.files);
    },
    reset: function () {
      this.$refs.input.value = "";
    },
  },
};
</script>
    
<template>
  <div class="f-upload" :class="{ pending: pending, filed: filename != null }">
    <input
      type="file"
      multiple
      name="file"
      id="file"
      class="inputfile"
      ref="input"
      @click="reset()"
      @change="onFileChange($event)"
      :accept="accept"
    />
    <f-textfield
      readonly
      :input="filename ? filename : $vt('No file uploaded')"
      :pending="pending"
    >
      <template v-slot:label><slot name="label"></slot></template>
      <template v-slot:action>
        <f-button
          v-if="!filename || noDelete"
          :pending="pending"
          class="f-upload-button"
          type="tertiary"
          @click="click($event)"
          >{{ $vt('Upload') }}<f-icon icon="fa6-regular fa6-circle-up"></f-icon
        ></f-button>
        <f-button
          v-if="filename && !noDelete"
          :pending="pending"
          class="f-delete-button"
          type="tertiary negative"
          @click="$emit('delete', $event)"
          ><f-icon icon="fa6-trash"></f-icon
        ></f-button>
      </template>
      <template v-slot:helper><slot name="helper"></slot></template>
    </f-textfield>
  </div>
</template>

<style lang="scss">
.f-upload {
  position: relative;

  &.filed {
    .f-input-container {
      input.f-input {
        color: #161615;
      }
    }
  }

  .f-input-container {
    input.f-input {
      color: rgba(22, 22, 21, 0.25);
      width: 0;
      flex: 1 1 auto;
    }
    input.f-input[readonly] {
      cursor: default;
    }
  }

  .inputfile {
    width: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
  }

  .f-input-container .f-right .f-action .f-button.f-upload-button,
  .f-input-container .f-right .f-action .f-button.f-delete-button {
    width: auto;
    padding: 0 8px;
    font-size: 12px;
    line-height: 12px;
  }

  .f-input-container .f-right .f-action .f-button.f-delete-button {
    width: 40px;
    height: 32px;
    font-size: 14px;
    line-height: 14px;
  }
}

.dark-mode {
  .f-upload {
    &.filed {
      .f-input-container {
        input.f-input {
          color: var(--white-a50);
        }
      }
    }

    .f-input-container {
      input.f-input {
        color: var(--white-a50);
      }
    }
  }
}
</style>